// ── Animal Avatars ──
export const ANIMALS = [
  { id: "fox", name: "Fox", color: "#F97316", emoji: "🦊" },
  { id: "parrot", name: "Parrot", color: "#22C55E", emoji: "🦜" },
  { id: "tiger", name: "Tiger", color: "#EAB308", emoji: "🐯" },
  { id: "rabbit", name: "Rabbit", color: "#EC4899", emoji: "🐰" },
  { id: "owl", name: "Owl", color: "#8B5CF6", emoji: "🦉" },
  { id: "penguin", name: "Penguin", color: "#06B6D4", emoji: "🐧" },
  { id: "panda", name: "Panda", color: "#64748B", emoji: "🐼" },
  { id: "cat", name: "Cat", color: "#F59E0B", emoji: "🐱" },
  { id: "bear", name: "Bear", color: "#92400E", emoji: "🐻" },
  { id: "dolphin", name: "Dolphin", color: "#3B82F6", emoji: "🐬" },
  { id: "raccoon", name: "Raccoon", color: "#6B7280", emoji: "🦝" },
  { id: "deer", name: "Deer", color: "#D97706", emoji: "🦌" },
  { id: "zebra", name: "Zebra", color: "#1F2937", emoji: "🦓" },
  { id: "koala", name: "Koala", color: "#9CA3AF", emoji: "🐨" },
  { id: "otter", name: "Otter", color: "#78716C", emoji: "🦦" },
];

// ── Ranks (7 Progressive - every 10 items) ──
export const RANKS = [
  { rank: 1, name: "Cabin Boy", threshold: 0, location: "The Docks", desc: "Every great journey starts at the harbor!", icon: "⚓" },
  { rank: 2, name: "Deckhand", threshold: 3, location: "Crusoe's Island", desc: "A deserted isle of discovery!", icon: "🏝️" },
  { rank: 3, name: "Sailor", threshold: 6, location: "Coral Bay", desc: "Sailing through sparkling waters!", icon: "⛵" },
  { rank: 4, name: "Bosun", threshold: 10, location: "Odyssey Cove", desc: "Charting ancient waters!", icon: "🧭" },
  { rank: 5, name: "Navigator", threshold: 15, location: "Sherwood Forest", desc: "The enchanted wood of wisdom!", icon: "🌲" },
  { rank: 6, name: "First Mate", threshold: 25, location: "Narnia's Edge", desc: "Beyond the wardrobe of wonder!", icon: "🦁" },
  { rank: 7, name: "Captain", threshold: 40, location: "Treasure Island", desc: "Commander of the seas!", icon: "🏴‍☠️" },
  { rank: 8, name: "Admiral", threshold: 60, location: "The Golden Fleet", desc: "Treasures untold await!", icon: "💎" },
  { rank: 9, name: "World Traveler", threshold: 100, location: "The Tome of Legends", desc: "Master of all seas!", icon: "📖" },
];

// ── Streak-Based Milestones ──
export const MILESTONES = [
  { count: 5, reward: "Diamond Ring", icon: "💍", color: "#DC2626" },
  { count: 10, reward: "Silver Ring", icon: "🔘", color: "#9CA3AF" },
  { count: 15, reward: "Pearl Necklace", icon: "📿", color: "#F5F5DC" },
  { count: 20, reward: "Diamond Crown", icon: "👑", color: "#60A5FA" },
  { count: 25, reward: "Gold Goblet", icon: "🏆", color: "#FFC107" },
  { count: 30, reward: "Jeweled Sword", icon: "⚔️", color: "#8B5CF6" },
  { count: 35, reward: "Pile of 5 Diamonds", icon: "💎", color: "#38BDF8" },
  { count: 40, reward: "Golden Crown", icon: "👑", color: "#D97706" },
  { count: 50, reward: "The Legendary Treasure", icon: "🏴‍☠️", color: "#FFC107" },
];

// ── Encouragement Messages ──
export const ENCOURAGEMENT = [
  "Look how far you've come!",
  "You're doing amazing! Keep going!",
  "Every word you learn is treasure in your heart!",
  "Your treasure chest is growing!",
  "What a wonderful adventurer you are!",
  "The seas are yours to conquer!",
  "Your memory is stronger than you think!",
  "Each poem is a golden coin of wisdom!",
  "You're sailing toward greatness!",
  "The best treasures are the ones you carry in your mind!",
  "Keep going, brave explorer!",
  "Your journey is inspiring!",
  "One more step toward the next treasure!",
  "The wind is at your back today!",
  "You're building a library in your heart!",
  "What an incredible collection you're growing!",
  "Every day of practice makes you stronger!",
  "You're a true treasure hunter!",
  "The adventure continues! Onward!",
  "Your dedication shines like gold!",
  "Wow! You made it!",
  "That was brilliant! You've got this!",
  "Another gem added to your collection!",
  "You're lighting up the map with your progress!",
];

// ── Milestone Celebration Messages ──
export const MILESTONE_MESSAGES = [
  "Incredible! You've earned a treasure reward!",
  "What a milestone! Open your treasure chest!",
  "You've unlocked something special!",
  "A new treasure awaits you, brave explorer!",
  "The treasure chest is glowing - something amazing is inside!",
];

// ── Type Configuration with generated icon images ──
export const TYPE_CONFIG = {
  poetry: { label: "Poetry", color: "#A855F7", bg: "#F3E8FF", emoji: "📜" },
  scripture: { label: "Scripture", color: "#F59E0B", bg: "#FEF3C7", emoji: "📖" },
  quote: { label: "Quote", color: "#06B6D4", bg: "#CFFAFE", emoji: "💬" },
  document: { label: "Document", color: "#3B82F6", bg: "#DBEAFE", emoji: "📄" },
  song: { label: "Song", color: "#FB7185", bg: "#FFE4E6", emoji: "🎵" },
  other: { label: "Other", color: "#4ADE80", bg: "#DCFCE7", emoji: "✨" },
};

// ── Store Accessories with visual descriptions ──
export const STORE_CATEGORIES = [
  { id: "pants", label: "Pants", unlockRank: 1, items: [
    { id: "blue_pants", name: "Sailor Blues", color: "#3B82F6", cost: 2, desc: "Classic navy sailor trousers", pattern: "solid" },
    { id: "red_pants", name: "Captain's Crimson", color: "#EF4444", cost: 2, desc: "Bold red adventure pants", pattern: "solid" },
    { id: "green_pants", name: "Forest Greens", color: "#22C55E", cost: 2, desc: "Woodland explorer leggings", pattern: "solid" },
    { id: "gold_pants", name: "Golden Threads", color: "#FFC107", cost: 3, desc: "Shimmering golden trousers", pattern: "shimmer" },
  ]},
  { id: "shirt", label: "Shirts", unlockRank: 2, items: [
    { id: "striped_shirt", name: "Sailor Stripes", color: "#3B82F6", cost: 3, desc: "Blue and white nautical stripes", pattern: "stripes", stripeColor: "#fff" },
    { id: "red_vest", name: "Adventurer's Vest", color: "#EF4444", cost: 3, desc: "A rugged red leather vest", pattern: "solid" },
    { id: "green_tunic", name: "Robin's Tunic", color: "#22C55E", cost: 4, desc: "A forest-green adventure tunic", pattern: "solid" },
    { id: "gold_jacket", name: "Captain's Coat", color: "#FFC107", cost: 5, desc: "Majestic gold captain's jacket", pattern: "shimmer" },
  ]},
  { id: "bandana", label: "Bandanas", unlockRank: 3, items: [
    { id: "red_bandana", name: "Pirate's Red", color: "#EF4444", cost: 3, desc: "Classic red pirate bandana", pattern: "dots" },
    { id: "blue_bandana", name: "Ocean Wave", color: "#3B82F6", cost: 3, desc: "Deep blue sea bandana", pattern: "wave" },
    { id: "green_bandana", name: "Jungle Wrap", color: "#22C55E", cost: 4, desc: "Tropical green headwrap", pattern: "leaf" },
    { id: "gold_bandana", name: "Royal Band", color: "#FFC107", cost: 5, desc: "Shining golden headband", pattern: "shimmer" },
  ]},
  { id: "hat", label: "Hats", unlockRank: 4, items: [
    { id: "sailor_hat", name: "Sailor Cap", color: "#F8FAFC", cost: 5, desc: "A crisp white sailor's cap", pattern: "solid", accent: "#1E3A5F" },
    { id: "captain_hat", name: "Captain's Tricorn", color: "#1E3A5F", cost: 6, desc: "A distinguished navy tricorn", pattern: "solid", accent: "#FFC107" },
    { id: "brown_tricorn", name: "Buccaneer's Hat", color: "#6B3A1F", cost: 7, desc: "A rugged brown leather tricorn", pattern: "leather" },
    { id: "eyepatch", name: "Eyepatch", color: "#1F2937", cost: 4, desc: "A classic pirate eyepatch", pattern: "solid" },
  ]},
  { id: "weapon", label: "Items", unlockRank: 5, items: [
    { id: "wooden_sword", name: "Wooden Cutlass", color: "#92400E", cost: 5, desc: "A trusty wooden practice sword", pattern: "wood" },
    { id: "flute", name: "Silver Flute", color: "#C0C0C0", cost: 5, desc: "A gleaming silver instrument", pattern: "metallic" },
    { id: "lute", name: "Bard's Lute", color: "#B45309", cost: 6, desc: "A beautifully crafted lute", pattern: "wood" },
    { id: "metal_dagger", name: "Metal Dagger", color: "#9CA3AF", cost: 7, desc: "A gleaming steel dagger", pattern: "metallic" },
  ]},
  { id: "tool", label: "Tools", unlockRank: 6, items: [
    { id: "telescope", name: "Brass Telescope", color: "#D97706", cost: 6, desc: "See distant lands!", pattern: "metallic" },
    { id: "compass", name: "Golden Compass", color: "#0EA5E9", cost: 6, desc: "Never lose your way", pattern: "metallic" },
    { id: "satchel", name: "Explorer's Satchel", color: "#92400E", cost: 7, desc: "Carry your treasures", pattern: "leather" },
    { id: "treasure_map", name: "Ancient Map", color: "#F5DEB3", cost: 8, desc: "Shows hidden treasures!", pattern: "parchment", emoji: "🗺️" },
  ]},
];

// ── Gold Coin Image URL ──
export const GOLD_COIN_URL = `data:image/svg+xml,${encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><defs><radialGradient id="g" cx="35%" cy="30%"><stop offset="0" stop-color="%23FFF3A0"/><stop offset=".55" stop-color="%23FBBF24"/><stop offset="1" stop-color="%23D97706"/></radialGradient></defs><circle cx="32" cy="32" r="29" fill="url(%23g)" stroke="%2392400E" stroke-width="3"/><circle cx="32" cy="32" r="22" fill="none" stroke="%23FDE68A" stroke-width="2"/><path d="M32 16l4.3 8.8 9.7 1.4-7 6.8 1.7 9.7-8.7-4.6-8.7 4.6L25 33l-7-6.8 9.7-1.4z" fill="%23FFF7C2" stroke="%23B45309" stroke-width="1.5"/></svg>'
)}`;

// ── Milestone Visual Icons (actual treasure emoji) ──
export const TREASURE_ICONS = {
  "Diamond Ring": "💍",
  "Silver Ring": "🔘",
  "Pearl Necklace": "📿",
  "Diamond Crown": "👑",
  "Gold Goblet": "🏆",
  "Jeweled Sword": "⚔️",
  "Pile of 5 Diamonds": "💎",
  "Golden Crown": "👑",
  "The Legendary Treasure": "🏴‍☠️",
};

// ── Daily Goal (fixed at 5 minutes) ──
export const DAILY_GOAL_MINUTES = 5;

// ── Helper Functions ──
export function getRank(memorizedCount) {
  let current = RANKS[0];
  for (const r of RANKS) {
    if (memorizedCount >= r.threshold) current = r;
  }
  return current;
}

export function getNextRank(memorizedCount) {
  for (const r of RANKS) {
    if (r.threshold > memorizedCount) return r;
  }
  return null;
}

export function getNextMilestone(memorizedCount) {
  for (const m of MILESTONES) {
    if (m.count > memorizedCount) return m;
  }
  return null;
}

export function getRandomEncouragement() {
  return ENCOURAGEMENT[Math.floor(Math.random() * ENCOURAGEMENT.length)];
}

export function getRandomMilestoneMessage() {
  return MILESTONE_MESSAGES[Math.floor(Math.random() * MILESTONE_MESSAGES.length)];
}

export function getAnimal(animalId) {
  return ANIMALS.find(a => a.id === animalId) || ANIMALS[0];
}
